import './Form.css';
const EmailInput = ({ email, handleEmailChange, error }) => {
  return (
    <>
      <p>Sie erhalten den Downloadlink per E-Mail.</p>
      <p>
        Die E-Mail Adresse dient nur der Übermittlung des Downloadlinks und wird
        nicht dauerhaft gespeichert.
      </p>
      <label htmlFor="email" className="label-email-input">
        E-Mail Adresse*
      </label>
      <input
        name="email"
        type="text"
        aria-label="E-Mail Adresse"
        placeholder="E-Mail Adresse"
        value={email}
        onChange={handleEmailChange}
      />
      {error && <p className="error">{error}</p>}
    </>
  );
};

export default EmailInput;
